<script>
	// From Lucide
	import { Link } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Link class={iconClass} />
